import name from './name'

const selectSliceData = state => state[name]

const selectLoading = state => selectSliceData(state).loading

const selectResults = state => selectSliceData(state).results

const selectReportUrl = state => selectSliceData(state).reportUrl

export {
  selectLoading,
  selectResults,
  selectReportUrl
}
